import React from 'react'
import { Checkbox } from 'semantic-ui-react'

const MarkedDeleted = (props) => {
    const {
        label=null,
        onChange=()=>{},
        style={},
        ...rest
    } = props
    return (
        <Checkbox
            label={label}
            onChange={onChange}
            style={style}
            {...rest}
        />
    )
}

export default MarkedDeleted